module.exports = {
  // ================ TEXTS FOR SITE ELEMENTS ================
  p: {
    prgtitle: "SMART-TEAM-DEV-PORTAL [RU]",
    moredetailed: "Подробнее...",
    loadingdata: "Загрузка данных...",
    processing: "Обработка...",
    send: "Отправить",
    changetheme: "Сменить цветовую тему",
    usermenu: "Меню пользователя",
    userpage: "Параметры пользователя",
    userexit: "<i class='fa fa-sign-out'></i>&nbsp;&nbsp;Выйти",
    userlogin: "<i class='fa fa-sign-in'></i>&nbsp;&nbsp;Войти",
    gotoportal: "<i class='fa fa-share-square-o'></i>&nbsp;ПОРТАЛ",
    usrexit: "Выйти",
    usrlogin: "Войти",
    fieldlogin: "Логин",
    fieldpass: "Пароль",
    buttonlogin: "Войти",
    authFormTitle: "Форма авторизации пользователя",
    redirection: "Перенаправление...",
    changelng: "Change language",
    noscript: "ДЛЯ РАБОТЫ САЙТА НЕОБХОДИМО РАЗРЕШИТЬ ВЫПОЛНЕНИЕ СКРИПТОВ",
    error: "Ошибка",
    serverLogsTitle: "Системные логи"
  },
  ymaps: {
    pageTitle: "= Yandex-карта =",
    theRouteBuilt: "Маршрут построен",
    cantBuiltTheRoute: "Не могу построить маршрут. QueryString не корректен, должно быть так: ?from=...&to=....&through=",
    mileage: "Протяженность, км = ",
    time: "Время в пути, час = ",
    ymapsModuleWasLoaded: "Модуль Yandex-карт загружен",
    yandexMapsIsNotLoaded: "Модуль Yandex-карт не был загружен. Возможно он отключен Администратором",
    couldNotBuildAroute: "Не смог построить маршрут",
    pageNotFound: "Страница %ymapsLink% не доступна",
    minimumAddressesRequired: "Количество адресов в массиве 'addresses' должно быть не менее 2"
  },
  e: {
    missingADhash: "Srvbg-server отклонил вашу авторизацию. Вы должны находиться во Внутренней сети. Вы забыли включить VPN?",
    nullLoginOrPass: "Отсутствуют требуемые аргументы - login & pass",
    incorrectOldPassword: "Неправильный старый пароль",
    userLoggedFailed: "Ошибка авторизации",
    incorrectAuthCode: "Неверный код авторизации",
    lifetimeAuthCode: "Время жизни кода авторизации истекло",
    candFindOnlineComputer: "Не могу найти компьютер пользователя со статусом 'online'",
    errorPageTitle: "Ошибка на стороне сервера при попытке рендеринга страницы",
    fileNotFound: "Файл не найден",
    fileconversionerror: "Ошибка конвертации файла",
    pserror: "Ошибка выполнения PowerShell-скрипта",
    userIsNotFound: "Пользователь не найден",
    userIsNotInInternalNetwork: "Пользователь не находится во внутренней сети предприятия",
    userIsNotInAllowedGroupsForSiteLogin: "Пользователь не входит в разрешенную группу для авторизации на сайте",
    thisSiteAllowOnlyADauthentication: "Этот сайт допускает только аутентификацию пользователей из Active Directory!",
    userDoesntHavePhoneAuthType: "У пользователя отключена авторизация по коду на телефон",
    userDoesntHaveMessengersIDs: "У пользователя (в настройках или в ActiveDirectory) не указан ни один ID мессенджера (viberid, whatsappid, telegramid)",
    cantsendmessage: "Не могу отправить сообщение",
    incorrentfields: "Не все поля заполнены корректно",
    qrcodenouri: "Не передан URI для кодировки QR-кода",
    banned: "Вы заблокированы!",
    incorrectHostName1: "Неверное имя хоста",
    incorrectHostName2: "Возможно это ошибка DNS-сервера. Выполните команду 'ipconfig /flushdns', очистите кэш браузера (Ctrl + Shift + Del), перезапустите браузер",
    userDisabled: "Пользователь отключен",
    chartnodata: "Не переданы данные для построения графика",
    adTestError: "Ошибка подключения к ActiveDirectory",
    adUserCantChangePwdThisWay: "Пользователь ActiveDirectory не может так менять пароль. Нажмите Ctrl+Alt+Del и выберете 'Изменить пароль'",
    unknownError: "Неизвестная ошибка",
    somethingWrong: "Что-то пошло не так",
    recIsNotFoundInDB: "Запись не найдена в базе данных",
    emptyDatabaseResult: "Запрос в базу данных вернул пустой массив",
    cryptoError2: "Не удалось расшифровать данные с клиента. Некорректный ключ, data или iv!"
  },
  w: {
    userLoggedError1: "Это была ",
    userLoggedError2: " попытка за последний час. Если вы отправите неправильные данные 5 раз, вы будете заблокированы!",
    apiOnlyForLAN: "API-функции разрешены только для пользователей внутри локальной сети или для Доверенных внешних IP-адресов",
    attentionban: "Вы пока не заблокированы. Но если это случится, то только владелец сайта сможет исключить вас из черного списка.",
    nothingUpdated: "Ничего не обновлено",
    onlyOneTimeCanCallSSOauthorization: "Только один раз можно авторизоваться через SSO",
    resetAppSettingsNothing: "У приложения 'appname' отсутствовали настройки в базе данных (уже загружены заводские настройки)",
    thisLoginAlreadyExistInAD: "Этот логин пользователя уже существует! Введите новое значение",
    notYetDeveloped: "Еще не доработано..."
  },
  i: {
    userLoggedSuccess: "Вы успешно авторизовались",
    messagesent: "Сообщение отправлено",
    finish: "Готово",
    updatedFields: "Обновленные поля: ",
    newADuserHasBeenCreated: "Новый пользователь ActiveDirectory успешно создан!",
    userIsInInternalNetwork: "Пользователь находится во внутренней сети предприятия",
    adTestSuccess: "Подключение к ActiveDirectory прошло успешно",
    settingsHasBeenSaved: "Настройки сохранены",
    generalSettingsHasBeenSaved: "Настройки сохранены. ",
    programWillRestart: "Программа будет перезапущена на стороне сервера",
    passwordWasChangedSuccess: "Пароль изменен успешно",
    successDeleted: "Удалено успешно",
    successUpdated: "Успешно Обновлено",
    successCreated: "Создано успешно", // not used
    successOperation: "Завершено успешно", // not used
    nothingHasChanged: "Ничего не измененилось"
  },
  unit: {
    pcs: "шт",
    m: "м",
    m2: "м²",
    m3: "м³",
    mm: "мм",
    kg: "кг"
  },
  // ================ IMAGES ================
  img: {
    programmerisworking: { title: "Программист работает над этим разделом сайта.", src: "/img/general/programmer-is-working.png" }
  },
  ag: {
    successDeleted: "Удалено успешно",
    successUpdated: "Успешно Обновлено",
    successCreated: "Создано успешно",
    successOperation: "Завершено успешно"
  },
  gpt: {
    chatGPTdisabled: "ChatGPT отключен Администратором в настройках программы",
    chatGPTtoken: "Необходимо указать API-ключ в конфигурационном файле",
    chatGPTproxy: "Для доступа к api.openai.com необходимо указать прокси-сервер в файле конфигурации",
    userDoesntHaveEnoughRightsToWorkWithGPT: "Вы не имеете достаточных прав для анализа этой таблицы при помощи ChatGPT",
    userDoesntHaveEnoughRightsToRunVoiceCommands: "Вы не имеете достаточных прав для выполнения голосовых комманд",
    thereAreNoDataForAnalysis: "Нет данных для анализа",
    incorrectRequest: "Некорректный запрос",
    incorrectDatePeriod: "Некорректный период дат для построения запроса",
    speechRecognitionError: "Ошибка распознавания речи",
    speechRecognitionNull: "Нет записанного сообщения. Нечего распознавать",
    undefinedEmployee: "Не удалось определить о каких сотрудниках идет речь",
    undefinedCommand: "Команда не входит в перечень разрешенных действий. Ознакомьтесь с перечнем допустимых команд перед вызовом голосового помощника",
    noAnswerFromChatGPT: "Нет ответа от chatGPT",
    ansWasCopiedToBuffer: "Ответ AI скопирован в буфер",
    copyToBufferError: "Возникла ошибка при копировании в буфер обмена",
    voiceRecordingStart: "Идет запись голоса с микрофона",
    voiceRecordingStop: "Запись голоса остановлена",
    micPermissionsError: "Отсутствуют права доступа к микрофону вашего устройства",
    tooltip1: "Анализ данных этой таблицы при помощи ChatGPT",
    tooltip2: "Отдать голосовую команду"
  },
  viber: {
    viberBotOnSubscribe: `Привет! Я Вайбер-бот. Вы сможете получать от меня сообщения в Viber о текущих задачах и другие оповещения. 
     Но сначала мне нужно идентифицировать вас. Отправьте мне свой номер телефона в таком формате: +79100000000`,
    viberBotNeedSubscribe: "Сначала мне нужно идентифицировать вас. Отправьте свой номер телефона в таком формате: +79100000000",
    viberBotUnderstandOnlyTextMessages: "Извините. Я понимаю только текстовые сообщения",
    viberBotDummyAnswer: "Писать комменты в этот чат не нужно. Никто их все-равно не увидит. Чат работает только в одну сторону Bot -> Viber",
    viberBotIsAlreadyKnownYou: "Вы уже зарегистрированы в Viber-боте",
    userWithThisPhoneNotFound: "Пользователь с этим телефоном не найден в базе данных 'users'",
    viberBotHello1: "Привет, ",
    viberBotHello2: "! Ваш ID: ",
    viberBotHello3: ". Вы успешно подключились к этому чату и теперь будете получать сообщения от Viber-бота",
    userHasAlreadyAnotherId: "Пользователь с этим номером телефона имеет другой Viber-ID. Только Администратор имеет право изменять Viber-ID у существующих пользователей",
    viberBotDisabledByAdmin: "ViberBot отключен Администратором"
  },
  telegram: {
    telegramBotOnSubscribe: `Привет! Я Telegram-бот. Вы сможете получать от меня сообщения в Telegram о текущих задачах и другие оповещения. 
     Но сначала мне нужно идентифицировать вас. Отправьте мне свой номер телефона в таком формате: +79100000000`,
    telegramBotNeedSubscribe: "Сначала мне нужно идентифицировать вас. Отправьте свой номер телефона в таком формате: +79100000000",
    telegramBotUnderstandOnlyTextMessages: "Извините. Я понимаю только текстовые сообщения",
    telegramBotDummyAnswer: "Писать комменты в этот чат не нужно. Никто их все-равно не увидит. Чат работает только в одну сторону Bot -> Telegram",
    telegramBotIsAlreadyKnownYou: "Вы уже зарегистрированы в Telegram-боте",
    userWithThisPhoneNotFound: "Пользователь с этим телефоном не найден в базе данных 'users'",
    telegramBotHello1: "Привет, ",
    telegramBotHello2: "! Ваш ID: ",
    telegramBotHello3: ". Вы успешно подключились к этому чату и теперь будете получать сообщения от Telegram-бота",
    userHasAlreadyAnotherId: "Пользователь с этим номером телефона имеет другой Telegram-ID. Только Администратор имеет право изменять Telegram-ID у существующих пользователей",
    telegramBotDisabledByAdmin: "TelegramBot отключен Администратором",
    telegramBotUserIsNotAuthorizedToRunCommands: "Пользователь не авторизован для выполнения команд",
    telegramBotUserDoesntHavePermission: "Пользователь не имеет достаточно прав для выполнения этой команды",
    botMessageSelectACommandInMainMenu: "Выберите команду для начала работы с Telegram-Bot",
    thereAreNoAwailCommandsForYou: "Права Вашего пользователя не позволяют выполнять команды в Telegram-Bot",
    helloUserIamChatGPTansYouQuestion: "*Приветствую, %username%. Вы выбрали 'Режим Искусственного Интеллекта'. Задайте Ваш вопрос*",
    theMainComands: "Чтобы вызвать Главное меню, набери '*меню*' или '*/menu*'.\nЧтобы начать диалог с ChatGPT набери '*Привет*'.\n"
      + "Чтобы передать файлы или фотографии на сервер - наберите команду '*файлы*' или '*/files*'. Можно будет выбрать папку с объектом куда будут сохранены файлы.\n"
      + "Если вы хотите прервать процесс, находясь в процессе заполнения путевых листов или в любом другом режиме - введите '*отмена*' или '*cancel*'.\n"
      + "Чтобы начать заново процесс (вызвать любую доступную команду) - наберите '*меню*'.\n"
      + "Справа в поле ввода текста в telegram появляется кнопка, при нажатии на которую Главное меню можно спрятать / показать (чтобы оно не мешало)",
    wayBills: {
      startMessage1: "*= Режим создания путевых листов и расчета поездок =\nВыберите действие*",
      startMessage2: "*= Режим создания путевых листов и расчета поездок =\nУ вас есть незавершенная поездка:*\n",
      startActions: [
        {text: "🛣️ Посчитать километраж и топливо", callback_data: "calcFuel"},
        {text: "🚗 Создать новую поездку", callback_data: "createNewTrip"},
        {text: "🏁 Завершить предыдущую поездку", callback_data: "finishLastTrip"},
        {text: "🛑 Вернуться в главное меню", callback_data: "menu"}
      ],
      selectedStartAction1: "_Режим расчета километража, времени и нужного количества топлива (без создания путевого листа)_",
      selectedStartAction2: "_Начало создания путевого листа (время прибытия можно будет дополнить по приезду в точку 'B')_",
      selectedStartAction3: "_Завершение ввода данных в незаконченный путевой лист_",
      selectAvto: "Выберите автомобиль",
      selectedAvto: "Автомобиль: _%selCar%_",
      selectFuelType: "Выберите тип топлива",
      selectedFuelType: "Топливо: _%selFuel%_",
      selectConditions: "Выберите условия эксплуатации",
      selectedConditions: "Условия: _%selCondition%_",
      startAddress: "Введите адрес отправления",
      startAddressValue: "Адрес отправления: _%startAddress%_",
      endAddress: "Введите адрес назначения",
      endAddressValue: "Адрес назначения: _%endAddress%_",
      doYouWantToSetMiddleAddress: "Желаете указать адрес промежуточной точки маршрута - 'через'?",
      middleAddress: "Введите адрес промежуточной точки",
      middleAddressValue: "Адрес промежуточной точки: _%middleAddress%_",
      startDateTime: "Введите дату и время отправления в формате 'ДД.ММ.ГГГГ час:мин'",
      endDateTime: "Введите дату и время прибытия в формате 'ДД.ММ.ГГГГ час:мин'",
      endDateTimeLater: "Заполню позже, когда приеду",
      curTime: "Текущее время",
      startDateTimeValue: "Дата и время отправления: _%startDateTime%_",
      endDateTimeValue: "Дата и время прибытия: _%endDateTime%_",
      odometerNum: "Введите показания одометра по приезду на целевой адрес",
      odometerValue: "Показания одометра по прибытию - _%odometerValue%_",
      tripIsCalculated: "🎯 Маршрут рассчитан:\n*Километраж = %mileage% км;\nРасчетное время = %duration% час;\nРасчетное количество топлива = %fuel% л.",
      downloadWayBill: "📑 *Путевой лист записан в базу данных Портала*. Скачать путевой лист можно по ссылке:",
      yamapsBuilding: "Открываю Yandex-Карты, прокладываю маршрут. Подождите 30 секунд пожалуйста...",
      doYouWantToContinueFillWayBill: "Продолжим заполнение путевого листа?",
      goodBye: "Рад был помочь! До свидания.\n\n_Чтобы вернуться в главное меню - наберите 'меню'_",
      createAnewTravelSheetNow: "Вы заполнили все необходимые данные.\n*Создать путевой лист на портале сейчас?*",
      editTravelSheetNow: "Вы заполнили все необходимые данные.\n*Внести изменения в существующий путевой лист на портале?*",
      thereIsExistSimilarWaybill: "*В базе данных уже есть похожий путевой лист. Не буду создавать дубликат!*"
    },
    botReturnToMainMenu: "🛑 Вернуться в главное меню",
    unknownCommand: "🚫 Неизвестная команда",
    notDevelopedYet: "🅾️ Еще не доработано...",
    youMustSelectInlineMenuItem: "⚠️ Вам нужно выбрать значение из списка",
    // Program TelegramBot
    mainButtons: [
      {
        key: "generalFunctions1", title: ["🚙 Авто", "🛣️ Поездки"], cfgCompany: "smartteamdev"
      },
      {
        key: "generalFunctions2", title: ["🧾 Чеки", "💵 Зарплата"], cfgCompany: "smartteamdev", safe: "hidden"
      },
      {
        key: "generalFunctions3", cfgCompany: "smartteamdev",
        title: ["🤖 ChatGPT", "🖥 Файлы - на сервер", "☢️ Задачи"]
      },
      {
        key: "accounting", cfgCompany: "smartteamdev", visForGroups: [
          "GC-ADMINS", "GC-HEADSHIP", "GC-SECRETARY", "GC-ACCHEADER", "GC-LAB-NDT-HEADER", "GC-LAB-MEX-HEADER", "GC-LAB-STROY-HEADER", "GC-LAB-EL-HEADER",
          "ATL-HEADSHIP", "ATL-ACCHEADER", "ATL-SECRETARY"
        ],
        title: ["📄 Счет в оплату", "💰 Поступившие платежи", "🛂 SKUD"], safe: "hidden"
      },
      {
        key: "cancel", title: ["🛑 Отмена", "📒 Помощь"]
      }
    ],
    waitMessages: [
      "🤖 Нужно подумать...",
      "🤖 Думаю...",
      "🤖 Вычисляю...",
      "🤖 Прикину что к чему...",
      "🤖 Нужно поразмыслить...",
      "🤖 Секунду...",
      "🤖 Анализирую данные...",
      "🤖 Работаю над этим...",
      "🤖 Сейчас сделаем...",
      "🤖 Шевелю винтиками...",
      "🤖 Только маме позвоню и отвечу...",
      "🤖 А самого, чё, не научили? Э-эх, так и быть - сделаю...",
      "🤖 Сейчас проснусь и сделаю...",
      "🤖 Мне нужно в Хьюстон позвонить, проконсультироваться...",
      "🤖 Братуха из Пентагона сейчас поможет...",
      "🤖 Пойду посоветуюсь с DeepSeek..."
    ]
  },
  mattermost: {
    mattermostBotNeedSubscribe: "Сначала мне нужно идентифицировать вас. Отправьте свой номер телефона в таком формате: +79100000000",
    mattermostBotIsAlreadyKnownYou: "Вы уже зарегистрированы в Mattermost-боте",
    mattermostBotHello1: "Привет, ",
    mattermostBotHello2: "! Ваш ID: ",
    mattermostBotHello3: ". Вы успешно подключились к этому чату и теперь будете получать сообщения от Mattermost-бота",
    userHasAlreadyAnotherId: "Пользователь с этим номером телефона имеет другой Mattermost-ID. Только Администратор имеет право изменять Mattermost-ID у существующих пользователей",
    mattermostBotDisabledByUser: "MattermostBot выключен пользователем",
    mattermostBotDisabledByAdmin: "MattermostBot отключен Администратором",
    mbotCommandError: "Ошибка обработки команды",
    mbotUnknownCommand: "Неизвестная команда",
    mbotDummyAnswer: "Логическая часть бота пока не может обрабатывать сообщения от пользователей",
    mattermostBotUserIsNotAuthorizedToRunCommands: "Пользователь не авторизован для выполнения команд",
    mattermostBotUserDoesntHavePermission: "Пользователь не имеет достаточно прав для выполнения этой команды",
    botMessageSelectACommandInMainMenu: "Выберите команду для начала работы с Mattermost-Bot",
    thereAreNoAwailCommandsForYou: "Права Вашего пользователя не позволяют выполнять команды в Mattermost-Bot",
    helloUserIamChatGPTansYouQuestion: "*Приветствую, %username%. Вы выбрали 'Режим Искусственного Интеллекта'. Задайте Ваш вопрос*",
    theMainComands: "Чтобы вызвать Главное меню, набери '*меню*' или '*menu*'.\nЧтобы начать диалог с ChatGPT набери '*Привет*' или '*Hi*'.\n"
      + "Чтобы передать файлы или фотографии на сервер - наберите команду '*файлы*' или '*files*'. Можно будет выбрать папку с объектом куда будут сохранены файлы.\n"
      + "Если вы хотите прервать процесс, находясь в процессе заполнения путевых листов или в любом другом режиме - введите '*отмена*' или '*cancel*'.\n"
      + "Чтобы начать заново процесс (вызвать любую доступную команду) - наберите '*меню*' или '*menu*'.",
    wayBills: {
      startMessage1: "*= Режим создания путевых листов и расчета поездок =\nВыберите действие*",
      startMessage2: "*= Режим создания путевых листов и расчета поездок =\nУ вас есть незавершенная поездка:*\n",
      startActions: [
        {text: "🛣️ Посчитать километраж и топливо", callback_data: "calcFuel"},
        {text: "🚗 Создать новую поездку", callback_data: "createNewTrip"},
        {text: "🏁 Завершить предыдущую поездку", callback_data: "finishLastTrip"},
        {text: "🛑 Отмена", callback_data: "cancel"}
      ],
      selectedStartAction1: "*Режим расчета километража, времени и нужного количества топлива (без создания путевого листа)*",
      selectedStartAction2: "*Начало создания путевого листа (время прибытия можно будет дополнить по приезду в точку 'B')*",
      selectedStartAction3: "*Завершение ввода данных в незаконченный путевой лист*",
      modalDlgTitle1: "Выберите параметры",
      submitButtonConfirmSelection: "Подтвердить выбор",
      submitButtonOK: "OK",
      selectAvto: "Выберите автомобиль",
      selectedAvto: "Автомобиль: *%selCar%*",
      selectFuelType: "Выберите тип топлива",
      selectedFuelType: "Топливо: *%selFuel%*",
      selectConditions: "Выберите условия эксплуатации",
      selectedConditions: "Условия: *%selCondition%*",
      selectedAvtoFuelConditions: "Автомобиль: *%selCar%*; Топливо: *%selFuel%*; Условия: *%selCondition%*",
      startAddress: "**Введите адрес отправления**",
      startAddressValue: "Адрес отправления: *%startAddress%*",
      endAddress: "**Введите адрес назначения**",
      endAddressValue: "Адрес назначения: *%endAddress%*",
      doYouWantToSetMiddleAddress: "Желаете указать адрес промежуточной точки маршрута - 'через'?",
      middleAddress: "**Введите адрес промежуточной точки**",
      middleAddressValue: "Адрес промежуточной точки: *%middleAddress%*",
      startDateTime: "**Введите дату и время отправления в формате 'ДД.ММ.ГГГГ час:мин'**",
      endDateTime: "**Введите дату и время прибытия в формате 'ДД.ММ.ГГГГ час:мин'**",
      endDateTimeLater: "Заполню позже, когда приеду",
      curTime: "Текущее время",
      startDateTimeValue: "Дата и время отправления: *%startDateTime%*",
      endDateTimeValue: "Дата и время прибытия: *%endDateTime%*",
      odometerNum: "Введите показания одометра по приезду на целевой адрес",
      odometerValue: "Показания одометра по прибытию - *%odometerValue%*",
      tripIsCalculated: "🎯 Маршрут рассчитан:\n*Километраж = %mileage% км;\nРасчетное время = %duration% час;\nРасчетное количество топлива = %fuel% л.",
      downloadWayBill: "📑 *Путевой лист записан в базу данных Портала*. Скачать путевой лист можно по [ссылке](%wayBillLink%)",
      yamapsBuilding: "Открываю Yandex-Карты, прокладываю маршрут. Подождите 30 секунд пожалуйста...",
      doYouWantToContinueFillWayBill: "Продолжим заполнение путевого листа?",
      goodBye: "Рад был помочь! До свидания.\n\n*Чтобы вернуться в главное меню - наберите 'меню'*",
      createAnewTravelSheetNow: "Вы заполнили все необходимые данные.\n*Создать путевой лист на портале сейчас?*",
      editTravelSheetNow: "Вы заполнили все необходимые данные.\n*Внести изменения в существующий путевой лист на портале?*",
      thereIsExistSimilarWaybill: "*В базе данных уже есть похожий путевой лист. Не буду создавать дубликат!*"
    },
    botMainMenu: "☰ Главное меню ☰",
    botReturnToMainMenu: "🛑 Вернуться в главное меню",
    unknownCommand: "🚫 Неизвестная команда",
    notDevelopedYet: "🅾️ Еще не доработано...",
    youMustSelectInlineMenuItem: "⚠️ Вам нужно выбрать значение из списка",
    youMustTypeSomeTextInTheFields: "⚠️ Вы должны заполнить поля текстом в соответствии со смысловым значением полей",
    // Program Mattermost-Bot
    mainButtons: [
      {
        key: "generalFunctions1", text: "Автотранспорт:", cfgCompany: "smartteamdev",
        actions: [{key: "avto", title: "🚙 Авто"}, {key: "trips", title: "🛣️ Поездки"}]
      },
      {
        key: "generalFunctions2", text: "Мои расходы и зарплата:", cfgCompany: "smartteamdev",
        actions: [{key: "cashierschecks", title: "🧾 Чеки"}, {key: "salary", title: "💵 Зарплата", safe: "hidden"}]
      },
      {
        key: "generalFunctions3", text: "ИИ, Файлы, Задачи:", cfgCompany: "smartteamdev",
        actions: [{key: "chatgpt", title: "🤖 ChatGPT"}, {key: "files", title: "🖥 Файлы - на сервер"}, {key: "tasks", title: "☢️ Задачи"}]
      },
      {
        key: "accounting", text: "Бухгалтерия", cfgCompany: "smartteamdev", safe: "hidden", visForGroups: [
          "GC-ADMINS", "GC-HEADSHIP", "GC-SECRETARY", "GC-ACCHEADER", "GC-LAB-NDT-HEADER", "GC-LAB-MEX-HEADER", "GC-LAB-STROY-HEADER", "GC-LAB-EL-HEADER",
          "ATL-HEADSHIP", "ATL-ACCHEADER", "ATL-SECRETARY"
        ],
        actions: [{key: "bill", title: "📄 Счет в оплату"}, {key: "payments", title: "💰 Поступившие платежи"}, {key: "skud", title: "🛂 SKUD"}]
      },
      {
        key: "cancel", text: "",
        actions: [{key: "cancel", title: "🛑 Отмена"}, {key: "help", title: "📒 Помощь"}]
      }
    ],
    waitMessages: [
      "🤖 Нужно подумать...",
      "🤖 Думаю...",
      "🤖 Вычисляю...",
      "🤖 Прикину что к чему...",
      "🤖 Нужно поразмыслить...",
      "🤖 Секунду...",
      "🤖 Анализирую данные...",
      "🤖 Работаю над этим...",
      "🤖 Сейчас сделаем...",
      "🤖 Шевелю винтиками...",
      "🤖 Только маме позвоню и отвечу...",
      "🤖 А самого, чё, не научили? Э-эх, так и быть - сделаю...",
      "🤖 Сейчас проснусь и сделаю...",
      "🤖 Мне нужно в Хьюстон позвонить, проконсультироваться...",
      "🤖 Братуха из Пентагона сейчас поможет...",
      "🤖 Пойду посоветуюсь с DeepSeek..."
    ]
  },
  chatGPT: {
    thinking: "✍🏼 Думаю...",
    botGeneratingAnswer: "Бот генерирует ответ..."
  },
  api1c: {
    c1disabled: "Модуль API 1C отключен Администратором",
    c1LinkIsNull: "В настройках программы не указан URI для API 1C (oData)",
    c1AuthIsNull: "В настройках программы не указаны Учетные данные для API 1C (oData)",
    accessDenied: "Доступ к API 1C (oData) запрещен. Некорректные учетные данные",
    cantFind1Cserver: "Не смог найти подходящий для данной функции сервер 1С в настройках программы",
    dbNameNotSpecified: "Не указано имя базы данных",
    companyNotSpecified: "Не указано имя компании / компаний",
    cantGetAnyRecordsets: "Не смог получить из 1С ни одной записи",
    unknownError: "При обращении к API 1C (oData) произошла неизвестная ошибка"
  },

  /// ===========  site =========== ///

  navbar: {
    logoText: "SmartTeamDev",
    home: "Главная",
    portal: "Portal",
    services: "Сервисы",
    media: "Медиа",
    contact: "Контакты",
    requestDemo: "Демо-версия",
    languageLabel: "Язык",
    langRu: "Русский",
    langEn: "English",
    langTr: "Türkçe",
    menuAriaLabel: "Навигация SmartTeamDev",
    hamburgerAriaLabel: "Открыть меню"
  },
  footer: {
    logoText: "SmartTeamDev",
    description: "Корпоративный портал и цифровые сервисы для команд.",
    productsTitle: "Разделы",
    productPortal: "Portal",
    productServices: "Сервисы",
    productProjects: "Проекты",
    productMedia: "Медиа",
    companyTitle: "Компания",
    companyContact: "Контакты",
    companyPrivacy: "Конфиденциальность",
    companyDocs: "Документы",
    companySupport: "Поддержка",
    contactsTitle: "Контакты",
    phone: "+7 (495) 123-45-67",
    email: "demo@smartteamdev.ru",
    address: "Москва, демо-офис",
    copyright: "© 2026 SmartTeamDev",
    scrollTopAriaLabel: "Наверх"
  },
  common: {
    title: "SmartTeamDev",
    description: "Демо-сайт SmartTeamDev",
    loading: "Загрузка",
    error: "Ошибка",
    close: "Закрыть"
  }
};
